import { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';

// ATTENTION: 当前只有主图支持在舞台上直接使用消除笔，这里就仅针对该场景进行处理
export const useEliminateInit = () => {
    const identity = useIdentity();
    const framework = getFramework(identity);

    // 控制隐藏、显示素材层
    useEffect(() => {
        // 禁用图层选中事件，取消激活图层
        framework.operate.disablePick();
        framework.operate.disableActive();

        setTimeout(() => {
            framework.operate.delActiveLayer();
        }, 0);

        return () => {
            // 恢复图层选中事件
            framework.operate.enablePick();
            framework.operate.enableActive();
        };
    }, []);
};
